/**
 * Online authentication: Auth0. The ONLY module allowed to import
 * `@auth0/auth0-react`; everything else goes through `authAdapter.js`.
 */
import React from 'react';
import {
  Auth0Provider,
  useAuth0,
  withAuthenticationRequired,
} from '@auth0/auth0-react';

// Wraps the tree with the AZmed Auth0 tenant configuration.
export const AppAuthProvider = ({ children }) => (
  <Auth0Provider
    domain="login.azmed.co"
    clientId={'k7gx9ituAFngRyTcqD1I2wbt3xDiCKcc'}
    authorizationParams={{
      redirect_uri: window.location.origin,
      scope: 'openid profile email app:azviewer',
    }}
    cacheLocation="localstorage"
  >
    {children}
  </Auth0Provider>
);

// Auth state and actions, backed by Auth0
export const useAppAuth = useAuth0;

// HOC redirecting to the Auth0 login when not authenticated
export const withAppAuthRequired = withAuthenticationRequired;
